var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 12C29.5 10.8954 30.3954 10 31.5 10C32.6046 10 33.5 10.8954 33.5 12V16C33.5 17.1046 32.6046 18 31.5 18C30.3954 18 29.5 17.1046 29.5 16V12Z",
    fill: "#A79FBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 25C15.5 24.4477 15.9477 24 16.5 24H19.5C20.0523 24 20.5 24.4477 20.5 25V27C20.5 27.5523 20.0523 28 19.5 28H16.5C15.9477 28 15.5 27.5523 15.5 27V25Z",
    fill: "#A79FBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 32C15.5 31.4477 15.9477 31 16.5 31H19.5C20.0523 31 20.5 31.4477 20.5 32V34C20.5 34.5523 20.0523 35 19.5 35H16.5C15.9477 35 15.5 34.5523 15.5 34V32Z",
    fill: "#A79FBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 24C22.9477 24 22.5 24.4477 22.5 25V27C22.5 27.5523 22.9477 28 23.5 28H26.5C27.0523 28 27.5 27.5523 27.5 27V25C27.5 24.4477 27.0523 24 26.5 24H23.5Z",
    fill: "#A79FBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 32C22.5 31.4477 22.9477 31 23.5 31H26.5C27.0523 31 27.5 31.4477 27.5 32V34C27.5 34.5523 27.0523 35 26.5 35H23.5C22.9477 35 22.5 34.5523 22.5 34V32Z",
    fill: "#A79FBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 25C29.5 24.4477 29.9477 24 30.5 24H33.5C34.0523 24 34.5 24.4477 34.5 25V27C34.5 27.5523 34.0523 28 33.5 28H30.5C29.9477 28 29.5 27.5523 29.5 27V25Z",
    fill: "#A79FBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 31C29.9477 31 29.5 31.4477 29.5 32V34C29.5 34.5523 29.9477 35 30.5 35H33.5C34.0523 35 34.5 34.5523 34.5 34V32C34.5 31.4477 34.0523 31 33.5 31H30.5Z",
    fill: "#A79FBD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 13H16.5V16C16.5 17.6569 17.8431 19 19.5 19C21.1569 19 22.5 17.6569 22.5 16V13H28.5V16C28.5 17.6569 29.8431 19 31.5 19C33.1569 19 34.5 17.6569 34.5 16V13H37.5C38.6046 13 39.5 13.8954 39.5 15V37C39.5 38.1046 38.6046 39 37.5 39H13.5C12.3954 39 11.5 38.1046 11.5 37V15C11.5 13.8954 12.3954 13 13.5 13ZM13.5 23C13.5 21.8954 14.3954 21 15.5 21H35.5C36.6046 21 37.5 21.8954 37.5 23V35C37.5 36.1046 36.6046 37 35.5 37H15.5C14.3954 37 13.5 36.1046 13.5 35V23Z",
    fill: "#A79FBD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10C18.3954 10 17.5 10.8954 17.5 12V16C17.5 17.1046 18.3954 18 19.5 18C20.6046 18 21.5 17.1046 21.5 16V12C21.5 10.8954 20.6046 10 19.5 10Z",
    fill: "#A79FBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.a8275485f42e00bc3cda0bf0a72419b4.svg";
export { ForwardRef as ReactComponent };